import { modalPrimaryActionAttribute } from './modal-primary-action-attribute';
/**
 * `onKeyDown` handler that activates a modal's / dialog's primary action when the user
 * presses `Cmd` + `Enter` (macOS) or `Ctrl` + `Enter` (Windows/Linux).
 *
 * Attach it to the root element of a modal/dialog. The primary action is found by looking
 * for the first descendant carrying {@link modalPrimaryActionAttribute}, which lets a
 * `type="submit"` button submit its form and an `onClick` button run its handler — without
 * either of them having to know about the shortcut.
 *
 * Disabled primary buttons are inert, so the shortcut is a no-op while the action is
 * unavailable. The handler also bails out when the event was already handled by a nested
 * component (e.g. a rich text editor that submits on `Cmd` + `Enter` itself).
 *
 * @param event the keyboard event, whose `currentTarget` is searched for the primary action
 *
 * @example
 * <MuiDialog open={open} onKeyDown={triggerModalPrimaryAction}>...</MuiDialog>
 */
export const triggerModalPrimaryAction = (event) => {
    if (event.defaultPrevented || event.key !== 'Enter' || !(event.metaKey || event.ctrlKey)) {
        return;
    }
    const primaryAction = event.currentTarget.querySelector(`[${modalPrimaryActionAttribute}]`);
    if (!primaryAction) {
        return;
    }
    event.preventDefault();
    primaryAction.click();
};
